export const remSize = window.getComputedStyle(document.documentElement).fontSize;
export const sidebarWidth = "240px";
export const minHeaderHeight = "72px";
export const boxShadow = "0 0 2px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1)";
export const borderRadius = "5px";
export const oneColumnContentWidth = "692px";
export const oneNarrowColumnContentWidth = "692px";
export const twoColumnsContentWidth = "1050px";
